import { App } from '@df/core/app';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
export namespace NUgcImageGallery {
    export const BASE_FIELDS = [
        <NICmsContentField.IField>{
            key: 'title',
            type: NICmsContentField.EFieldType.text,
            title: 'Title',
        },
        <NICmsContentField.IField>{
            key: 'subtitle',
            type: NICmsContentField.EFieldType.text,
            title: 'Subtitle',
        },
        <NICmsContentField.IField>{
            key: 'cta',
            type: NICmsContentField.EFieldType.text,
            title: 'CTA',
            required: true
        },
        <NICmsContentField.IField>{
            key: 'message',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Message'
        },
        NICmsContentComponent.backgroundField
    ];

    export const FIELDS = [
        ...BASE_FIELDS,
        <NICmsContentField.INumberField>{
            key: 'limit',
            type: NICmsContentField.EFieldType.number,
            title: 'Load Limit',
            step: 1,
            required: true,
            default: 20,
            min: 1
        }
    ];

    export const UGC_CATEGORY_FIELD: NICmsContentField.IChoiceField = {
        key: 'ugc_category',
        multiple: true,
        type: NICmsContentField.EFieldType.choice,
        title: 'UGC Category',
        options: () => {
            if (typeof window !== 'undefined') {
                const attr = (<App>window['app'])?.resources?.attribute?.get('ugc_category');
                if (attr?.data?.options) {
                    return attr.data.options.map(i => {
                        return {
                            key: i.value,
                            value: i.value,
                            title: i.label.toString()
                        };
                    });
                }
            }
            return [];
        }
    };
    export const UGC_RANGE_CODE_NH_FIELD: NICmsContentField.IChoiceField = {
        key: 'nyw_item_range_code_nh',
        multiple: true,
        type: NICmsContentField.EFieldType.choice,
        title: 'Range Code NH',
        options: () => {
            if (typeof window !== 'undefined') {
                const attr = (<App>window['app'])?.resources?.attribute?.get('nyw_item_range_code_nh');
                if (attr?.data?.options) {
                    return attr.data.options.map(i => {
                        return {
                            key: i.value,
                            value: i.value,
                            title: i.label.toString()
                        };
                    });
                }
            }
            return [];
        }
    };


    export const roomOptions = [
        { title: 'View All', key: undefined },
        { title: 'Living Room', key: 'living_room' },
        { title: 'Dining Room', key: 'dining_room' },
        { title: 'Bedroom', key: 'bedroom' },
        { title: 'Home Office', key: 'home_office' },
        { title: 'Garden', key: 'garden' },
        { title: 'Misc.', key: 'misc' }
    ];

    export const UGC_ROOM_FIELD: NICmsContentField.IChoiceField = {
        key: 'room',
        multiple: true,
        type: NICmsContentField.EFieldType.choice,
        title: 'Room',
        options: roomOptions.filter(i => !!i.key)
    };
    export interface IData extends NICmsContentComponent.IData {
        title: string;
        subtitle: string;
        cta: string;
        limit: number;
        showLimit?:number;
        ugc_category?: number | number[];
        nyw_item_range_code_nh?: number | number[];
        room?: string[];
        message?: string;
        hideFilters?:boolean;
        hideViewMoreInfo?: boolean;
        showShopTheLook?:boolean;
    }
    export interface IListingData extends IData {
        text?: string;
        initialStepsVisible: number;
        infScrollStep: number;
    }
}
